<template>
  <div class="rt-admin-wrapper" :class="classObj">
    <div
      v-if="'horizontal' === layout"
      class="layout-container-horizontal"
      :class="{
        fixed: header === 'fixed',
        'no-tabs-bar': tabsBar === 'false' || tabsBar === false,
      }"
    >
      <div :class="header === 'fixed' ? 'fixed-header' : ''">
        <vab-top-bar />
        <div
          v-if="tabsBar === 'true' || tabsBar === true"
          :class="{ 'tag-view-show': tabsBar }"
        >
          <div class="rt-main">
            <vab-tabs-bar />
          </div>
        </div>
      </div>
      <div class="rt-main main-padding">
        <vab-ad />
        <vab-app-main />
      </div>
    </div>
    <div
      v-else
      class="layout-container-vertical"
      :class="{
        fixed: header === 'fixed',
        'no-tabs-bar': tabsBar === 'false' || tabsBar === false,
      }"
    >
      <div
        v-if="device === 'mobile' && collapse === false"
        class="mask"
        @click="handleFoldSideBar"
      />
      <my-vab-side-bar />
      <div class="rt-main" :class="collapse ? 'is-collapse-main' : ''">
        <div :class="header === 'fixed' ? 'fixed-header' : ''">
          <vab-nav-bar />
          <vab-tabs-bar v-if="tabsBar === 'true' || tabsBar === true" />
        </div>
        <vab-ad />
        <vab-app-main />
      </div>
    </div>
    <el-backtop />
    <Dialog :dialogShow="dialogShow" title="修改密码" @maskClick="maskClick">
      <template>
        <el-form
          ref="form"
          :model="form"
          :rules="rules"
          class="updatePasswordForm"
          label-position="right"
          label-width="100px"
          :hide-required-asterisk="true"
        >
          <el-row>
            <el-col class="form-item-col" :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
              <el-form-item prop="oldPassword" label="旧密码">
                <el-input
                  placeholder="请输入旧密码"
                  v-model.trim="form.oldPassword"
                  type="password"
                  autocomplete="off"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col class="form-item-col" :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
              <el-form-item prop="newPassword" label="新密码">
                <el-input
                  placeholder="新密码必须包含大小写字母及数字（8位数以上）"
                  v-model.trim="form.newPassword"
                  type="password"
                  autocomplete="off"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col class="form-item-col" :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
              <el-form-item prop="passwordOk" label="确认密码">
                <el-input
                  placeholder="请输入新密码"
                  v-model.trim="form.passwordOk"
                  type="password"
                  autocomplete="off"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="btn-row">
            <el-button
              class="login-btn"
              type="default"
              @click="maskClick"
            >
              取消
            </el-button>
            <el-button
              type="primary"
              @click="confirm"
              :loading="loading"
            >
              确认
            </el-button>
          </el-row>
        </el-form>
      </template>
    </Dialog>
  </div>
</template>

<script>
  import { isNull } from '@/utils/validate'
  import Dialog from '@/components/Dialog/index'
  import { mapActions, mapGetters } from 'vuex'
  import { tokenName } from '@/config'
  import myVabSideBar from '@/components/VabSideBar'
  import { api_putRestPassword } from '@/api/user'
  export default {
    name: 'Layout',
    data() {
      const validateoldPassword = (rule, value, callback) => {
        if (isNull(value)) {
          callback(new Error('旧密码不能为空'))
        } else {
          callback()
        }
      }
      const validatePassword = (rule, value, callback) => {
        if (isNull(value)) {
          callback(new Error('新密码不能为空'))
        } else {
          callback()
        }
      }
      const validatePasswordOk = (rule, value, callback) => {
        if (isNull(value)) {
          callback(new Error('确认密码不能为空'))
        } else {
          callback()
        }
      }
      return {
        loading: false,
        oldLayout: '',
        form: {
          oldPassword: '',
          newPassword: '',
          passwordOk: ''
        },
        rules: {
          oldPassword: [
            {
              required: true,
              trigger: 'blur',
              validator: validateoldPassword,
            },
          ],
          newPassword: [
            {
              required: true,
              trigger: 'blur',
              validator: validatePassword,
            },
          ],
          passwordOk: [
            {
              required: true,
              trigger: 'blur',
              validator: validatePasswordOk,
            },
          ],
          loading: false
        }}
    },
    components: {
      myVabSideBar,
      Dialog
    },
    computed: {
      ...mapGetters({
        layout: 'settings/layout',
        tabsBar: 'settings/tabsBar',
        collapse: 'settings/collapse',
        header: 'settings/header',
        device: 'settings/device',
        dialogShow: 'user/dialogShow',
      }),
      classObj() {
        return {
          mobile: this.device === 'mobile',
        }
      },
    },
    beforeMount() {
      window.addEventListener('resize', this.handleResize)
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.handleResize)
    },
    mounted() {
      this.oldLayout = this.layout
      const isMobile = this.handleIsMobile()
      if (isMobile) {
        if (isMobile) {
          //横向布局时如果是手机端访问那么改成纵向版
          this.$store.dispatch('settings/changeLayout', 'vertical')
        } else {
          this.$store.dispatch('settings/changeLayout', this.oldLayout)
        }
        this.$store.dispatch('settings/toggleDevice', 'mobile')
        setTimeout(() => {
          this.$store.dispatch('settings/foldSideBar')
        }, 2000)
      } else {
        this.$store.dispatch('settings/openSideBar')
      }
      this.$nextTick(() => {
        window.addEventListener(
          'storage',
          (e) => {
            if (e.key === tokenName || e.key === null) window.location.reload()
            if (e.key === tokenName && e.value === null)
              window.location.reload()
          },
          false
        )
      })
    },
    methods: {
      ...mapActions({
        handleFoldSideBar: 'settings/foldSideBar',
      }),
      maskClick () {
        this.form = {}
        this.$store.dispatch('user/setDialogShow', false)
      },
      handleIsMobile() {
        return document.body.getBoundingClientRect().width - 1 < 992
      },
      handleResize() {
        if (!document.hidden) {
          const isMobile = this.handleIsMobile()
          if (isMobile) {
            //横向布局时如果是手机端访问那么改成纵向版
            this.$store.dispatch('settings/changeLayout', 'vertical')
          } else {
            this.$store.dispatch('settings/changeLayout', this.oldLayout)
          }

          this.$store.dispatch(
            'settings/toggleDevice',
            isMobile ? 'mobile' : 'desktop'
          )
        }
      },
      confirm () {
        this.$refs.form.validate(async (valid) => {
          if (valid) {
            if (this.form.newPassword === this.form.passwordOk) {
              this.loading = true
              try {
                await api_putRestPassword({oldPassword: this.form.oldPassword, newPassword: this.form.newPassword})
                this.$baseMessage('密码修改成功', 'success')
                this.loading = false
                this.maskClick()
                await this.$store.dispatch('user/logout', true)
                this.$router.replace(`/login`)
              } catch (error) {
                this.loading = false
              }
            } else {
              this.$baseMessage(`密码不一致，请重新填写`, 'error')
            }
          } else {
            return false
          }
        })
      }
    },
  }
</script>

<style lang="scss" scoped>
  @mixin fix-header {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    z-index: $base-z-index - 2;
    width: 100%;
    overflow: hidden;
  }

  .rt-admin-wrapper {
    position: relative;
    width: 100%;
    height: 100%;

    .layout-container-horizontal {
      position: relative;

      &.fixed {
        padding-top: calc(#{$base-top-bar-height} + #{$base-tabs-bar-height});
      }

      &.fixed.no-tabs-bar {
        padding-top: $base-top-bar-height;
      }

      ::v-deep {
        .rt-main {
          width: 88%;
          margin: auto;
        }

        .fixed-header {
          @include fix-header;
        }

        .tag-view-show {
          background: $base-color-white;
          box-shadow: $base-box-shadow;
        }

        .nav-bar-container {
          .fold-unfold {
            display: none;
          }
        }

        .main-padding {
          .app-main-container {
            margin-top: $base-padding;
            margin-bottom: $base-padding;
            background: $base-color-white;
          }
        }
      }
    }

    .layout-container-vertical {
      position: relative;

      .mask {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: $base-z-index - 1;
        width: 100%;
        height: 100vh;
        overflow: hidden;
        background: #000;
        opacity: 0.5;
      }

      &.fixed {
        padding-top: calc(#{$base-nav-bar-height} + #{$base-tabs-bar-height});
      }

      &.fixed.no-tabs-bar {
        padding-top: $base-nav-bar-height;
      }

      .rt-main {
        position: relative;
        min-height: 100%;
        margin-left: $base-left-menu-width;
        background: #f6f8f9;
        transition: $base-transition;

        ::v-deep {
          .fixed-header {
            @include fix-header;

            left: $base-left-menu-width;
            width: $base-right-content-width;
            box-shadow: $base-box-shadow;
            transition: $base-transition;
          }

          .nav-bar-container {
            position: relative;
            box-sizing: border-box;
          }

          .tabs-bar-container {
            box-sizing: border-box;
          }

          .app-main-container {
            width: calc(100% - #{$base-padding} - #{$base-padding});
            margin: $base-padding auto;
            background: $base-color-white;
            border-radius: $base-border-radius;
          }
        }

        &.is-collapse-main {
          margin-left: $base-left-menu-width-min;

          ::v-deep {
            .fixed-header {
              left: $base-left-menu-width-min;
              width: calc(100% - #{$base-left-menu-width-min});
            }
          }
        }
      }
    }

    /* 手机端开始 */
    &.mobile {
      ::v-deep {
        .el-pager,
        .el-pagination__jump {
          display: none;
        }

        .layout-container-vertical {
          .el-scrollbar.side-bar-container.is-collapse {
            width: 0;
          }

          .rt-main {
            width: 100%;
            margin-left: 0;
          }
        }

        .rt-main {
          .fixed-header {
            left: 0 !important;
            width: 100% !important;
          }
        }
      }
    }

    /* 手机端结束 */
  }
  .updatePasswordForm{
    margin-top: 30px;
    padding-right: 20px;
    box-sizing: border-box;
    .btn-row{
      padding-top: 20px;
      float: right;
      overflow: hidden;
      box-sizing: border-box;
      .el-button + .el-button{
        margin-left: 20px;
      }
      button{
        border: 0;
        width: 110px;
        height: 34px;
        padding: 0;
        line-height: 34px;
        text-align: center;
        font-size: 16px;
      }
    }
    ::v-deep {
      .el-input{
        border-radius: 2px;
        font-size: 16px;
        .el-input__inner{
          background: #F2F3F5;
        }
        .el-input__inner:focus{
          background: #fff;
          border: 1px solid #05C8AF;
        }
      }
      .el-input.is-focus{
        .el-input__inner{
          background: #fff;
        }
      }
    }
  }
</style>
